import Paragraph from '@/components/atoms/Paragraph';
import SHeading from '@/components/atoms/SHeading';
import Image from 'next/image';
import React from 'react';

type SuggestPlaceCardProps = {
  heading: string;
  altText: string;
  description: string;
  imageSrc?: string;
  className?: string;
};

const SuggestPlaceCard: React.FC<SuggestPlaceCardProps> = ({ heading, altText, description, imageSrc }) => {
  return (
    <div className="grid grid-cols-2 gap-4 bg-primary-light overflow-hidden text-ellipsis">
      <div className='w-full flex justify-center'>
        {imageSrc && <Image src={imageSrc} alt={altText} width={162} height={0} className='w-auto h-full' />}
      </div>
      <div className='py-4 pr-2'>
        <SHeading text={heading} className="!leading-normal font-semibold pb-2" />
        <Paragraph className="text-md" text={description} size={16} />
      </div>
    </div>
  );
};

export default SuggestPlaceCard;
